import { useContext } from "react";
import { TimeRangeContext } from "../context/TimeRangeContext";

export default function NoData(props: {
    error: string | null,
    loading: boolean, length: number
}) {
    const { error, loading, length } = props;
    const timeRangeContext = useContext(TimeRangeContext);
    const isAutorefresh = timeRangeContext.timeRange.autorefresh

    if (error) {
        return (
                <div className="w-100 text-center text-muted my-3">
                    <i className="fal fa-ban fa-fw fa-2x"></i>
                    <p className="mt-3">
                        {error}
                    </p>
                </div>
        )
    } else if (loading && !isAutorefresh) {
        return (
                <div className="w-100 text-center text-muted my-3">
                    <div className="loader spinner">
                    </div>
                    <p className="mt-3">
                        Loading data...
                    </p>
                </div>
        )
    }  else if (length === 0) {
        return (
                <div className="w-100 text-center text-muted my-3">
                    <i className="fal fa-ban fa-fw fa-2x"></i>
                    <p className="mt-3">
                        No data found
                    </p>
                </div>
        )
    } else {
        return (
            <></>
        )
    }
}
